import React, { Component } from "react";
import useMousePosition from "./../hooks/useMousePosition";

const Scrolled = () => {
	const { x, y } = useMousePosition();
	
	
	function handleNavigation(){
		if (document.getElementsByClassName('c-splash').length > 0) {
			if (document.getElementsByClassName('c-splash')[0].clientHeight > window.scrollY) {
				document.getElementsByTagName( 'html' )[0].classList.remove('state-scrolled');
			} else {
				document.getElementsByTagName( 'html' )[0].classList.add('state-scrolled');
			}
		} else {
			document.getElementsByTagName( 'html' )[0].classList.add('state-scrolled');
		}
	}

	if (document.getElementsByClassName('c-splash').length > 0) {
		if (document.getElementsByClassName('c-splash')[0].clientHeight > window.scrollY) {
			document.getElementsByTagName( 'html' )[0].classList.remove('state-scrolled');
		} else {
			document.getElementsByTagName( 'html' )[0].classList.add('state-scrolled');
		}
	} else {
		document.getElementsByTagName( 'html' )[0].classList.add('state-scrolled');
	}
	window.addEventListener("scroll", (e) => handleNavigation(e));


	return (
    	<></>
	);
};

export default Scrolled;